import React from 'react';

export const CenturionNetworkLounges = () => {
  return <div>CenturionNetworkLounges</div>;
};
